import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import awsConfig from './aws-exports';
import Amplify, { Auth } from 'aws-amplify';
Amplify.configure(awsConfig);
if (environment.production) {
  enableProdMode();
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", function () {
    navigator.serviceWorker.register('push-sw.js').then((registration) => {
        console.info(`ServiceWorker registration successful with scope: ${registration.scope}`);
        return registration.update();
    }).then((registration) =>{
        console.info(`ServiceWorker updated`, registration)
      }).catch((err) =>{
        console.error("ServiceWorker registration failed: ", err)}
      );
      if (navigator.serviceWorker.controller) {
          console.log("This page is currently controlled by:",navigator.serviceWorker.controller);
      }
  });
}


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log("Error from Main.ts: ",err));
